import { useContext } from 'react'
import { AuthContext } from '@contexts/AuthContext'
import ForcePasswordChangeModal from './ForcePasswordChangeModal'

export default function ForcePasswordChangeWrapper({ children }) {
  const { forcePasswordChange, clearForcePasswordChange, isAuthenticated } = useContext(AuthContext)

  const handlePasswordChanged = () => {
    clearForcePasswordChange()
    // Recarrega a página para garantir que o usuário tenha acesso completo
    window.location.reload()
  }

  // Só mostra o modal se:
  // 1. O usuário está autenticado
  // 2. E precisa trocar a senha
  if (isAuthenticated && forcePasswordChange) {
    return (
      <ForcePasswordChangeModal
        isOpen={true}
        onPasswordChanged={handlePasswordChanged}
      />
    )
  }

  // Caso contrário, renderiza normalmente
  return children
}
